import OllieAssistant from "components/ollie-assistant/ollie-assistant";

const featureFlagOllieChatEnabled = process.env.REACT_APP_FF_OLLIE_CHAT_ENABLED == "true";

const OllieLayout = ({ children }: { children: React.ReactNode }) => {
	return (
		<div className="ir-container">
			<div className="id-decorative-bg" />
			<main className="ir-main">{children}</main>
			{featureFlagOllieChatEnabled && <OllieAssistant />}
		</div>
	);
};

export default OllieLayout;
